import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { CustomerCard } from './customer-card.entity'

export class CustomerCardsRepository extends BaseRepository<CustomerCard> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.paymentApiUrl + '/cards', token, cache)
    }
}
